import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { PlusOutlined } from '@ant-design/icons';
import { postt } from '../ApiSeervice';
import { useHistory } from 'react-router-dom';
import { getProjectById, deleteProject, updateProjectservice } from '../ApiSeervice';
import {
    Button,
    InputNumber,
    DatePicker,
    Descriptions,
    Form,
    Input,
    Select,
    Upload,
    message,
    Spin
} from 'antd';
import '../../App.css'

const { TextArea } = Input;



const normFile = e => {
    if (Array.isArray(e)) {
        return e;
    }
    return e === null || e === void 0 ? void 0 : e.fileList;
};




const convertPhotosToFileList = (photos) => {
    if (!photos || photos.length === 0) return [];

    return photos.map((photo, index) => ({
        uid: `${-index - 1}`,            // Negatif uid (yeni eklenenlerle çakışmaz)
        name: photo.path.split('/').pop(), // Dosya adını path'ten al
        status: 'done',
        url: photo.path,                 // Fotoğrafın URL'si
        thumbUrl: photo.path,            // Küçük önizleme için
    }));
};

const AddProject = () => {
    const navigate = useHistory();
    const { id: urlId } = useParams();
    const [id, setId] = useState(null);
    const [form] = Form.useForm();
    const [project, SetProject] = useState([]);
      const [loading, setLoading] = useState(false);

 
    const onFinish = async values => {
    setLoading(true); // loading başlat
        const formData = new FormData();
        formData.append('ProjectArea', values.projectArea);
        formData.append('Id', urlId);
        formData.append('Place', values.place);
        formData.append('StartDate', values.StartDate.format('YYYY-MM-DD')); // ISO formatında gönder
        formData.append('Duration', values.duration);
        formData.append('Title', values.title);
        formData.append('Description', values.description);
        formData.append('Type', values.type);
     for (let pair of formData.entries()) {
            console.log(pair[0] + ': ' + pair[1]);
        }

        values.photos.forEach(photo => {
            if (!photo.originFileObj) {
                formData.append('PhotosPaths', photo.name);
            }
            else {
                formData.append('Files', photo.originFileObj);
            }
        });
   


       try {
             console.log("asds")
             let response = await updateProjectservice(formData);
             console.log(response);
             if (response.status === 200) {
               message.success('Proje başarıyla güncellendi');
               navigate.push('/panel-options');
             } else {
               message.error('Proje güncellenemedi');
             }
           } catch (error) {
             message.error('Bir hata oluştu. Lütfen tekrar deneyin.');
             console.error(error);
           } finally {
             setLoading(false); // loading durdur
           }
    };

    async function deleteProjectt() {

        try {
            let response = await deleteProject(id);
            if (response.status == 200) {
                navigate.push('/panel-options');
                message.success('Proje başarıyla silindi');
            }
            else {
                message.success(' Proje silinemedi');
            }
        }
        catch (error) {
            // Hata mesajını burada yakalıyoruz
            message.error('Bir hata oluştu. Lütfen tekrar deneyin.');
            console.error(error);  // Hata detaylarını konsola yazdırıyoruz
        }
    }


    useEffect(() => {

        // Component ilk açıldığında state’leri yükle
        setId(urlId);


        async function fetchProject() {
            try {
                const projectt = await getProjectById(urlId);
                const projectWithConvertedPhotos = {
                    ...projectt,
                    photos: convertPhotosToFileList(projectt.photos),
                };
                SetProject(projectt);
                console.log(projectWithConvertedPhotos);  // Bunu da görmek istersin
                form.setFieldsValue(projectWithConvertedPhotos);
            }
            catch (error) {
                // Hata mesajını burada yakalıyoruz
                message.error('Bir hata oluştu. Lütfen tekrar deneyin.');
                console.error(error);  // Hata detaylarını konsola yazdırıyoruz
            }

        }
        fetchProject();


    }, [urlId]);
    return (
        <>

            <h1 style={{ marginLeft: "2vw" }}>Proje </h1>
            <div style={{ justifyContent: 'center', alignItems: 'center', display: 'flex', marginTop: '50px' }}>
                <Spin spinning={loading}>
                <Form
                           className='form'
                    form={form}
                    labelCol={{ span: 5 }}
           
                    layout="horizontal"
             
                    onFinish={onFinish}

                >


                    <Form.Item label="Başlık" name="title" rules={[{ required: true, message: 'Proje Başlığı Boş Olamaz' }]}>
                        <Input />
                    </Form.Item>


                    <Form.Item label="Yer" name="place" rules={[{ required: true, message: 'Proje Yeri Boş Olamaz' }]}>
                        <Input />
                    </Form.Item>

                       <Form.Item label="Tür" name="type" rules={[{ required: true, message: 'Proje Türü Boş Olamaz' }]}>
                                <Input />
                              </Form.Item>


                    <Form.Item label="Proje alanı" name="projectArea" rules={[{ required: true, message: 'Proje Alanı Boş Olamaz' }]}>
                        <InputNumber />
                    </Form.Item>


                    <Form.Item label="Başlangıç tarihi" name="StartDate" rules={[{ required: true, message: 'Projenin başlangıç tarihi boş olamaz' }]}>
                        <DatePicker format="YYYY-MM-DD" />
                    </Form.Item>

                    <Form.Item label="Süre" name="duration">
                        <Input />
                    </Form.Item>



                    <Form.Item label="Acıklama" name="description" rules={[{ required: true, message: 'Proje Açıklaması Boş Olamaz' }]}>
                        <TextArea rows={4} />
                    </Form.Item>

                    <Form.Item label="Resimler" name="photos" valuePropName="fileList" getValueFromEvent={normFile} rules={[{ required: true, message: 'Proje Resimleri Boş Olamaz' }]}>
                        <Upload listType="picture-card" accept="image/*"  >
                            <button
                                style={{ color: 'inherit', cursor: 'inherit', border: 0, background: 'none' }}
                                type="button"
                            >
                                <PlusOutlined />
                            </button>
                        </Upload>
                    </Form.Item>

                    <div style={{ display: 'flex',justifyContent: 'space-between' }}>
                        <Form.Item  >
                            <Button htmlType="submit" style={{ textTransform: 'none' }} >Tamam</Button>
                        </Form.Item>

                       
                          <Form.Item  >
                     <Button style={{ textTransform: 'none' }}type="primary" danger onClick={deleteProjectt}>Projeyi Sil</Button>
                     </Form.Item>
                    </div>
                           
                </Form>
                </Spin>
                  
            </div>
        </>
    );
};
export default AddProject;